/**
 * Ryan O'Dowd
 * 2025-07-31
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({isDarkMode, globalScale, colors}) => {
  return {
    container: {
      minWidth: 500,
    },
    note: {
      marginTop: globalScale * 8,
      color: isDarkMode ? colors.accent : colors.accentDark,
    },
    loadingProgressRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
  };
};

export default getStyles;
